var _mask, _rect, _mask2, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAgendaAddItemBelow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 17,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "agenda-add-item-below_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3.6,
  width: 14.4,
  height: 9.714,
  rx: 1
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 3.6,
  width: 14.4,
  height: 9.714,
  rx: 1,
  stroke: "#98A4AF",
  strokeWidth: 3.2,
  mask: "url(#agenda-add-item-below_svg__a)"
})), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
  id: "agenda-add-item-below_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3.6,
  y: 13.357,
  width: 14.4,
  height: 3.643,
  rx: 1
}))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 3.6,
  y: 13.357,
  width: 14.4,
  height: 3.643,
  rx: 1,
  fill: "#98A4AF",
  stroke: "#98A4AF",
  strokeWidth: 3.4,
  mask: "url(#agenda-add-item-below_svg__b)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.49 11.406.353 7.702a.2.2 0 0 0-.353.13v7.408a.2.2 0 0 0 .353.13l3.138-3.705a.2.2 0 0 0 0-.259ZM4.8 4h12v1.7h-12z",
  fill: "#98A4AF"
})));
export { SvgAgendaAddItemBelow as ReactComponent };
export default __webpack_public_path__ + "b2f64aa72c1300396a90516785da6787.svg";